<template>
    <transition name="fade">
        <div class="pvz-modal" v-if="isShowPvzModal">
            <div class="pvz-modal__dimmer"></div>
            <div class="pvz-modal__content">
                <div class="pvz-modal__header">
                    <div class="container text_11">
                        {{ $t("select_pick_up") }}
                        <div
                            class="pvz-modal__close like-link"
                            @click="
                                $emit('update:isShowPvzModal', false);
                                currentPvzIndex = false;
                            ">
                            {{ $t("close") }}
                        </div>
                    </div>
                </div>
                <div class="row grid-row row--fullwidth">
                    <transition name="fade">
                        <div class="col lg-6 sm-12 col--no-padding" v-if="mapReady || $device.isMobile">
                            <transition name="fade" mode="out-in">
                                <div class="pvz__left" v-if="currentPvzIndex !== false" key="detail">
                                    <div class="pvz-detail__header">
                                        <div class="pvz-detail__back like-link" @click="currentPvzIndex = false">
                                            <svg-icon name="arrow-left" width="16" height="16" />
                                            {{ $t("back_to_list") }}
                                        </div>
                                    </div>
                                    <div class="pvz-detail" v-bsl="currentPvzIndex !== false">
                                        <div class="container">
                                            <div class="pvz-detail__main">
                                                <div class="row flex-row">
                                                    <div class="col lg-8 sm-12">
                                                        <div class="pvz-detail__place text_13">
                                                            {{ currentPvz.address }}
                                                        </div>
                                                        <div class="pvz-detail__address color-text_2">
                                                            {{ currentPvz.metro }}
                                                        </div>
                                                    </div>
                                                    <div class="col lg-4 sm-12" v-if="currentPvzDeliveryInfo">
                                                        <div class="pvz-detail__price text_13 text_13--sm-11">
                                                            <template v-if="currentPvzDeliveryInfo.cost > 0">
                                                                {{
                                                                    currentPvzDeliveryInfo.cost.toLocaleString("ru-RU")
                                                                }}
                                                                <span class="money">{{ currency }}</span>
                                                            </template>
                                                            <template v-else>
                                                                {{ $t("free") }}
                                                            </template>
                                                        </div>
                                                        <div class="pvz-detail__date color-text_2">
                                                            {{ $t("deliver_in") }} {{ currentPvzDeliveryInfo.time }}
                                                            {{ currentPvzDeliveryInfo.time | pluralize(daysArr) }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="button button--dark button--medium"
                                                v-if="skus || isShowCountryForm"
                                                @click="$emit('choosePvz', currentPvz)">
                                                {{ $t("pick_up_here") }}
                                            </div>
                                            <div class="pvz-detail__table color-text_2">
                                                <div class="pvz-detail__trow" v-if="currentPvz.schedule">
                                                    <span>{{ $t("open_hours") }}</span>
                                                    <span>{{ currentPvz.schedule }}</span>
                                                </div>
                                                <div class="pvz-detail__trow" v-if="currentPvz.description">
                                                    <span>{{ $t("how_to_get") }}</span>
                                                    <span v-html="currentPvz.description"></span>
                                                </div>
                                                <div class="pvz-detail__trow" v-if="currentPvz.phone">
                                                    <span>{{ $t("phone") }}</span>
                                                    <span class="color-text_1"
                                                        ><a :href="'tel:' + currentPvz.phone">{{
                                                            currentPvz.phone
                                                        }}</a></span
                                                    >
                                                </div>
                                            </div>
                                            <div class="is_details">
                                                <PvzMap
                                                    @openPVZ="currentPvzIndex = $event"
                                                    @mapReady="mapReady = true"
                                                    :vendorCode="vendorCode"
                                                    :pvz="pvzFilteredList"
                                                    :activeMarkerIndex="currentPvzIndex"
                                                    v-if="$device.isMobile && pvzFilteredList.length" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pvz__left" v-else key="list">
                                    <div class="container">
                                        <div
                                            class="pvz__form"
                                            :class="{ 'pvz__form--no-title': hideTitle }"
                                            v-if="isShowCountryForm">
                                            <div class="text_15 text_bold" v-if="!hideTitle">
                                                {{ $t("pvz-form-title") }}
                                            </div>
                                            <div class="form-group small-column">
                                                <component
                                                    v-for="(input, name, inputIndex) in countryForm"
                                                    :key="inputIndex"
                                                    :is="input.type == 'select' ? 'Select' : 'Input'"
                                                    :hasSearch="input.hasSearch"
                                                    :name="name"
                                                    :fixedDropdown="input.fixedDropdown"
                                                    :type="input.type"
                                                    :label="input.label"
                                                    :options="input.options"
                                                    :required="input.required"
                                                    :inputClass="input.inputClass"
                                                    :labelClass="input.labelClass"
                                                    v-model="input.value"
                                                    @change="countryChange($event)"
                                                    @change-city="changeCity($event)"
                                                    :country="input.country"
                                                    :suggestion="input.suggestion"
                                                    :validationMessage="input.required ? input.validationMessage : ''"
                                                    :isValid="input.required ? input.isValid : true"
                                                    :labelDescription="input.labelDescription" />
                                            </div>
                                        </div>
                                        <transition name="fade">
                                            <div class="form-group" v-if="pvzFullList.length">
                                                <Input
                                                    name="pvzAddress"
                                                    :label="$t('yr_address_metro')"
                                                    :hasReset="true"
                                                    v-model="pvzAddress" />
                                            </div>
                                        </transition>
                                    </div>
                                    <div class="pvz-map" v-if="$device.isMobile">
                                        <div
                                            class="pvz-map__mobile-map-toggler color-text_1"
                                            :class="{
                                                is_open: isMobileMapOpen,
                                            }">
                                            <div class="text_11" @click="isMobileMapOpen = !isMobileMapOpen">
                                                <template v-if="isMobileMapOpen">
                                                    {{ $t("hide_map") }}
                                                    <svg-icon name="arrow-down" width="8" height="8" />
                                                </template>
                                                <template v-else>
                                                    {{ $t("show_map") }}
                                                    <svg-icon name="arrow-down" width="8" height="8" />
                                                </template>
                                            </div>
                                        </div>
                                        <div class="pvz-map__map" v-if="pvzFilteredList.length && isMobileMapOpen">
                                            <PvzMap
                                                @openPVZ="currentPvzIndex = $event"
                                                @mapReady="mapReady = true"
                                                :vendorCode="vendorCode"
                                                :pvz="pvzFilteredList"
                                                :activeMarkerIndex="currentPvzIndex" />
                                        </div>
                                    </div>
                                    <div class="pvz-list" v-bsl="isShowPvzModal" v-if="pvzFilteredList.length">
                                        <div
                                            class="pvz-item"
                                            v-for="(pvz, index) in pvzFilteredList"
                                            :key="index"
                                            @click="currentPvzIndex = index">
                                            <div class="pvz-item__place">
                                                {{ pvz.address }}
                                            </div>
                                            <div class="pvz-item__address color-text_2" v-if="pvz.metro">
                                                {{ $t("metro") }} {{ pvz.metro }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="container" v-else>
                                        {{ $t("nothinf_found") }}
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </transition>
                    <div class="col lg-6 col--no-padding" v-if="$device.isDesktop && pvzFilteredList.length">
                        <PvzMap
                            @openPVZ="currentPvzIndex = $event"
                            @mapReady="mapReady = true"
                            :vendorCode="vendorCode"
                            :pvz="pvzFilteredList"
                            :activeMarkerIndex="currentPvzIndex" />
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import PvzMap from "~/components/PvzMap";
import Input from "~/components/form/Input";
import Select from "~/components/form/Select";
export default {
    name: "PvzModal",
    components: { PvzMap, Input, Select },
    props: [
        "vendorCode",
        "isShowPvzModal",
        "pvzFullList",
        "currentPvzDeliveryInfo",
        "skus",
        "currency",
        "daysArr",
        "countries",
        "isShowCountryForm",
        "hideTitle",
    ],
    data() {
        return {
            mapReady: false,
            pvzAddress: "",
            currentPvzIndex: false,
            countryForm: {
                country: this.getCountryIso(),
                city: {
                    type: "text",
                    suggestion: true,
                    label: this.$i18n.t("city"),
                    isValid: true,
                    country: "",
                    validationMessage: "",
                    inputClass: "black-border text_11",
                    value: "",
                },
            },
            // боксберри доставляет только в эти страны
            allowCountries: ["RU", "KZ", "BY", "KG", "AM"],
            isMobileMapOpen: false,
        };
    },
    computed: {
        currentPvz() {
            if (this.currentPvzIndex !== false) {
                let pvz = this.pvzFilteredList[this.currentPvzIndex];
                if (this.isShowCountryForm) {
                    pvz.countryIso = this.countryForm.country.value;
                }
                return pvz;
            }
            return false;
        },
        pvzFilteredList() {
            return !this.pvzAddress
                ? this.pvzFullList
                : this.pvzFullList.filter((pvz) => {
                      return (
                          pvz.name.toLowerCase().includes(this.pvzAddress.toLowerCase()) ||
                          pvz.address.toLowerCase().includes(this.pvzAddress.toLowerCase()) ||
                          (pvz.metro ? pvz.metro.toLowerCase().includes(this.pvzAddress.toLowerCase()) : false)
                      );
                  });
        },
    },
    watch: {
        currentPvzIndex(val) {
            this.$emit("update:currentPvz", { index: val, pvz: this.currentPvz });
        },
        countries() {
            this.countryForm.country = this.getCountryIso();
        },
        isShowPvzModal() {
            this.pvzAddress = "";
            this.currentPvzIndex = false;
        },
    },
    methods: {
        countryChange(country) {
            if (country == "RU") {
                this.countryForm.city.value = "";
                this.countryForm.city.country = country;
                this.countryForm.city.type = "text";
            } else {
                this.countryForm.city.type = "hidden";
                this.countryForm.country.value = country;
                this.$emit("update:pvzFullList", { country: country, kladr: null });
            }
        },
        changeCity(city) {
            if (city) {
                this.$emit("update:pvzFullList", {
                    country: this.countryForm.country.value
                        ? this.countryForm.country.value
                        : Object.keys(this.countryForm.country.options)[0],
                    kladr: city.data.kladr_id,
                });
            } else {
                this.$emit("reset:pvzFullList");
            }
        },
        getCountryIso() {
            let options = {};
            if (this.countries && this.allowCountries) {
                Object.keys(this.countries).forEach((country_code) => {
                    if (this.allowCountries.indexOf(country_code) >= 0) {
                        options[country_code] = this.countries[country_code].fullName;
                    }
                });
            }
            let props = {
                fixedDropdown: true,
                hasSearch: true,
                label: this.$i18n.t("country"),
                isValid: true,
                validationMessage: "",
                type: "select",
                value: "",
                inputClass: "black-border text_11",
                options: options,
            };
            return props;
        },
    },
    mounted() {
        this.countryForm.country = this.getCountryIso();
    },
};
</script>
<style lang="less">
.pvz-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 112px 0;
    z-index: 5;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    @media @sm {
        padding: 0;
        z-index: 8;
        top: 77px;
    }
    &__dimmer {
        background: #f2f1e9;
        opacity: 0.7;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
    &__content {
        position: relative;
        z-index: 1;
        background: #fff;
        height: 100%;
        display: flex;
        flex-direction: column;
        > .row {
            flex-grow: 1;
            overflow: hidden;
            @media @sm {
                display: flex;
                flex-direction: column;
            }
            > .col {
                height: 100%;
                @media @sm {
                    flex-grow: 1;
                }
            }
        }
        .pvz__left {
            @media @sm {
                height: 100%;
                display: flex;
                flex-direction: column;
                > .container {
                    flex-grow: 0;
                    padding-bottom: 11px;
                }
            }
        }
    }
    &__header {
        background: @bg;
        border-bottom: 1px solid @border2;
        flex-shrink: 0;
        .container {
            height: 36px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &:before,
            &:after {
                display: none;
            }
        }
    }
    &__close {
        border-bottom: 1px solid;
    }
}
.pvz-map {
    &__mobile-map-toggler {
        padding: 16px 16px;
        display: flex;
        align-items: baseline;
        justify-content: center;
        svg {
            .trs(transform);
        }
        &.is_open {
            .text_11 {
                color: #000;
            }

            svg {
                transform: rotate(180deg);
            }
        }
    }
    &__map {
        position: relative;
        width: 100%;
        height: 430px;
    }
}
.pvz-list {
    margin-top: 24px;
    flex-grow: 1;
    overflow-y: auto;
    border-top: 1px @border2 solid;
    border-bottom: 1px @border2 solid;
    height: calc(100dvh - 321px);
    @media @sm {
        margin-top: 0;
    }
}
.pvz-item {
    padding: 16px 32px;
    cursor: pointer;
    .trs(background);
    @media @sm {
        padding: 16px;
    }
    & + & {
        border-top: 1px @border2 solid;
    }
    &:hover {
        background: @bg;
    }
    &__place {
        margin-bottom: 4px;
    }
}
.pvz-detail {
    flex-grow: 1;
    padding-top: 32px;
    @media @sm {
        overflow-y: scroll;
        overflow-x: hidden;
    }
    &__header {
        padding: 0 27px;
        display: flex;
        align-items: center;
        height: 35px;
        border-bottom: 1px solid @border2;
        @media @sm {
            flex-grow: 0;
            padding: 0 11px;
        }
    }
    &__back {
        display: flex;
        align-items: center;
        svg {
            margin-right: 8px;
        }
    }
    &__main {
        margin-bottom: 24px;
    }
    &__place,
    &__price,
    &__vendor {
        margin-bottom: 10px;
        .selectedPvz & {
            margin-bottom: 8px;
        }
        @media @sm {
            margin-bottom: 4px;
        }
    }
    &__price {
        @media @sm {
            margin-top: 8px;
        }
    }
    &__price,
    &__date {
        text-align: right;
        @media @sm {
            text-align: left;
        }
    }

    &__table {
        border-top: 1px solid @border2;
        margin: 32px -32px 0;
        padding-top: 20px;
    }
    &__trow {
        display: flex;
        justify-content: space-between;
        padding: 12px 0;
        margin: 0 32px;
        & + & {
            border-top: 1px solid @border2;
        }
        span {
            &:first-child {
                white-space: nowrap;
                padding-right: 32px;
            }
            + span {
                text-align: right;
                word-break: break-word;
            }
        }
    }
    .is_details {
        @media @sm {
            margin: 0 -16px;
            height: 240px;
            position: relative;
            #pvzMapContainer {
                height: 100%;
            }
        }
    }
}
.pvz__form {
    padding-top: 32px;
    &--no-title {
        padding-top: 0;
        .form-group__label {
            margin-top: 20px;
        }
    }
    .text_15.text_bold {
        margin-bottom: -20px;
    }
}
</style>
